import React, { useState } from "react";
import styles from "./BuyCostTile.module.css";
import Button from "../forms/Button/Button";
import IconEdit from "@/components/icons/IconEdit";
import VariableBuyCostModal from "@/app/inventory/VariableBuyCostModal/VariableBuyCostModal";
import { useInventoryContext } from "@/contexts/InventoryContext";
import Skeleton from "../Skeleton/Skeleton";
import { formatValue } from "@/utils/formatUtils";

export const BuyCostTile = ({
    buyCost=0,
    allowEdit=false,
    onEdit=() => {},
    isLoading=true,
}) => {
    if (isLoading) {
        return (
            <div className={styles.container}>
                <Skeleton width='50%' height={24} className={styles.title}/>
                <Skeleton width='50%' height={48} className={styles.buyCost}/>
            </div>
        );
    }

    return (
        <>
            <div className={styles.container}>
                <h3 className={styles.title}>Buy Cost Average</h3>
                {allowEdit && (
                    <Button type="text" className={styles.editButton} onClick={onEdit}>
                        <IconEdit width={16} height={16}/>
                    </Button>
                )}
                <h1 className={styles.buyCost}>
                    {formatValue(buyCost, "currency")}
                </h1>
            </div>
            {/* {variableBuyCostModalOpen && allowEdit &&
                <VariableBuyCostModal
                    inventoryItem={inventoryItem}
                    open={variableBuyCostModalOpen}
                    onOpenChange={(isOpen) => { setVariableBuyCostModalOpen(isOpen) }}
                    onClose={() => { setVariableBuyCostModalOpen(false) }}
                />
            } */}
        </>
        
    )
}